import { Property } from 'csstype';

import { Box, BoxProps } from '../Box';
import styled from '../../theme/styled-with-theme';
import { useTokenProp } from '../../theme/tokens/utils';
import { TokenProp } from '../../theme/tokens/types';

export interface FlexboxProps extends BoxProps {
  flexDirection?: TokenProp<Property.FlexDirection>;
  flexBasis?: Property.FlexBasis<string>;
  flexWrap?: Property.FlexWrap;
  alignContent?: Property.AlignContent;
  alignItems?: Property.AlignItems;
  justifyContent?: Property.JustifyContent;
  justifyItems?: Property.JustifyItems;
}

const useFlexProps = ({
  flexBasis,
  flexWrap,
  alignContent,
  alignItems,
  justifyContent,
  justifyItems,
}: FlexboxProps) => ({
  flexBasis,
  flexWrap,
  alignContent,
  alignItems,
  justifyContent,
  justifyItems,
});

const useFlexDirectionProp = useTokenProp<Property.FlexDirection, FlexboxProps>(
  'flex-direction',
  (props) => props.flexDirection,
  (props, flexDirection) => `${flexDirection || ''}`
);

export const Flexbox = styled(Box)<FlexboxProps>`
  display: flex;
  ${useFlexProps}
  ${useFlexDirectionProp}
`;
